var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasSlot || _vm.errorMessage)?_c(_setup.FieldNote,{attrs:{"color":"allred"}},[_c(_setup.Icon,{staticClass:"error-banner-icon",attrs:{"name":"alert"}}),_vm._v(" "),_vm._t("default",function(){return [_vm._v("\n\t\t"+_vm._s(_vm.errorMessage)+"\n\t")]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }